import type { Availabilities } from '@libs/data-access/entities'

export const CONTRACT_NOT_ELIGIBLE_PAID_LEAVE = ['intern', 'interim']

export const SUBMIT_TYPES = {
  DEFAULT: 'default',
  DELETE_PLANNABLES: 'deletePlannables',
  MOVE_TO_NEW_CONTRACT: 'moveToNewContract'
}

export const CONTRACT_TABS = {
  PLANNING: 'planning',
  WAGE: 'wage',
  CONTRACT: 'contract'
}

export const DEFAULT_AVAIBILITIES: Availabilities = {
  is_avail_1: 'available',
  is_avail_details_1: '',
  is_avail_2: 'available',
  is_avail_details_2: '',
  is_avail_3: 'available',
  is_avail_details_3: '',
  is_avail_4: 'available',
  is_avail_details_4: '',
  is_avail_5: 'available',
  is_avail_details_5: '',
  is_avail_6: 'available',
  is_avail_details_6: '',
  is_avail_0: 'available',
  is_avail_details_0: ''
}

export const USER_CONTRACT_FIELDS = [
  'firstname',
  'lastname',
  'contract_type',
  'contract_time',
  'contract_end_trial',
  'job',
  'location_id',
  'team_id',
  'do_not_show_in_register',
  'echelon_level',
  'echelon_number',
  'echelon_other',
  'daily_worker',
  'mensual_brut',
  'hourly_brut',
  'transportation',
  'iban',
  'bic',
  'work_permit_type',
  'work_permit_number',
  'work_permit_expiration_date',
  'contract_end_reason',
  'health_plan',
  'contract_start',
  'contract_end',
  'last_medical_examination_date',
  'enhanced_medical_examination',
  'availabilities',
  'team_ids',
  'team_id',
  'working_days_in_week',
  'has_minimum_wage',
  'temp_agency_name',
  'temp_agency_address',
  'temp_agency_zip',
  'temp_agency_city'
]
